import React from 'react';

const FeatureCard = ({ icon, title, description, comingSoon = false }) => (
  <div className="bg-white p-8 rounded-xl shadow-lg text-center relative">
    {comingSoon && (
      <span className="absolute top-4 right-4 bg-purple-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg z-10 select-none">
        Coming Soon!
      </span>
    )}
    <div className="flex justify-center mb-4">{icon}</div>
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-muted-foreground">{description}</p>
  </div>
);

export default FeatureCard; 